'use client'
import {
  IconItem_default,
  Location_default,
  Price_default,
  Sellers_default,
  Type_default
} from "./chunk-3RIFEIGI.mjs";
import {
  useConfig_default
} from "./chunk-ZSKGVFZ4.mjs";
import {
  ContentfulButton_default
} from "./chunk-N7S35DQG.mjs";
import {
  ThemeButton_default
} from "./chunk-VYWHMVWT.mjs";
import {
  CollapsableTextSection_default,
  CollapsableText_default
} from "./chunk-TAYU5GTT.mjs";
import {
  DecoratedSection_default
} from "./chunk-THREBTTP.mjs";
import {
  ContentfulMedia_default
} from "./chunk-IOBZ5NBW.mjs";
import {
  useFavorites
} from "./chunk-BB4H5TUC.mjs";
import {
  useItinerary
} from "./chunk-YBJOQHTL.mjs";
import {
  useCalendarQuery_default
} from "./chunk-PLJBED27.mjs";
import {
  useFilterQuery_default
} from "./chunk-7GAGCG6W.mjs";
import {
  removeDuplicateSlashes
} from "./chunk-GMNAQNNP.mjs";
import {
  useGetEventsList
} from "./chunk-TW33R6V4.mjs";
import {
  useGetCategories
} from "./chunk-HKGNX5TB.mjs";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/components/events/NumberedCarousel.tsx
import { Carousel, Typography as Typography4 } from "@wbk/ui";

// src/components/section/Title.tsx
import { twMerge } from "tailwind-merge";
import { Typography } from "@wbk/ui";
import { jsx, jsxs } from "react/jsx-runtime";
var SectionTitle = ({ section, className }) => {
  return /* @__PURE__ */ jsxs("div", { className: twMerge("relative space-y-2", className), children: [
    section.title && /* @__PURE__ */ jsx(Typography, { as: "h2", variant: "heading-XXL", children: section.title }),
    section.subtitle && /* @__PURE__ */ jsx(Typography, { children: section.subtitle })
  ] });
};
var Title_default = SectionTitle;

// src/components/events/card/Item.tsx
import { Fragment as Fragment2 } from "react";
import { Link, useRouter as useRouter2, useTranslation as useTranslation2 } from "@wbk/config";
import { twMerge as twMerge3 } from "tailwind-merge";
import { Button, Divider, Typography as Typography3 } from "@wbk/ui";
import { Heart } from "@wbk/svg";

// src/components/events/card/Date.tsx
import { useMemo } from "react";
import { formatDate } from "@wbk/utils";
import { twMerge as twMerge2 } from "tailwind-merge";
import { Typography as Typography2 } from "@wbk/ui";
import { useRouter, useTranslation } from "@wbk/config";
import { Fragment, jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var EventItemDate = ({ className, event, renderType = "full", dateType = "time" }) => {
  var _a;
  const { locale } = useRouter();
  const { t } = useTranslation("calendar_event");
  const { design } = useConfig_default();
  const dateInfo = useMemo(() => {
    if (!event.schedule)
      return {};
    if (event.schedule.text) {
      return { text: event.schedule.text };
    }
    if (!event.schedule.openDateTime)
      return {};
    const startDate = new Date(event.schedule.openDateTime);
    if (!event.schedule.closeDateTime || new Date(event.schedule.closeDateTime).setHours(0, 0, 0, 0) === new Date(event.schedule.openDateTime).setHours(0, 0, 0, 0)) {
      return { startDate };
    }
    const endDate = new Date(event.schedule.closeDateTime);
    return { startDate, endDate };
  }, [event.schedule]);
  if (!dateInfo.startDate && !dateInfo.text)
    return null;
  if (renderType === "mini") {
    return /* @__PURE__ */ jsx2("div", { className: "flex flex-col", children: /* @__PURE__ */ jsx2(Typography2, { variant: "label-XXS", children: dateInfo.text ? dateInfo.text : dateInfo.startDate ? dateType === "time" ? formatDate(dateInfo.startDate, locale, {
      hour12: false,
      hour: "2-digit",
      minute: "2-digit"
    }) : formatDate(dateInfo.startDate, locale, {
      day: "2-digit",
      month: "long",
      year: "numeric"
    }) : null }) });
  }
  const popVariant = "bg-body-level-1 rounded-XS -mt-10 p-2 border";
  const variant = (_a = design == null ? void 0 : design.eventItemDate) == null ? void 0 : _a.variant;
  return /* @__PURE__ */ jsxs2(
    "div",
    {
      className: twMerge2("gap-S flex h-fit flex-col", variant === "pop" && popVariant, className),
      children: [
        dateInfo.startDate && /* @__PURE__ */ jsxs2("div", { className: "flex flex-col", children: [
          /* @__PURE__ */ jsx2(Typography2, { variant: "heading-S", children: formatDate(dateInfo.startDate, locale, {
            day: "2-digit"
          }) }),
          /* @__PURE__ */ jsx2(Typography2, { variant: "body-S", className: "text-tertiary-800", children: formatDate(dateInfo.startDate, locale, {
            month: "short"
          }) })
        ] }),
        dateInfo.endDate && dateInfo.startDate && /* @__PURE__ */ jsxs2(Fragment, { children: [
          /* @__PURE__ */ jsx2(Typography2, { variant: "body-XS", className: "text-secondary-500", children: t("calendar_event:until") }),
          /* @__PURE__ */ jsxs2("div", { className: "flex flex-col", children: [
            /* @__PURE__ */ jsx2(Typography2, { variant: "heading-S", children: formatDate(dateInfo.endDate, locale, {
              day: "2-digit"
            }) }),
            /* @__PURE__ */ jsx2(Typography2, { variant: "body-S", className: "text-tertiary-800", children: formatDate(dateInfo.endDate, locale, {
              month: "short"
            }) })
          ] })
        ] }),
        dateInfo.text && /* @__PURE__ */ jsx2(Typography2, { variant: "heading-M", children: dateInfo.text })
      ]
    }
  );
};
var Date_default = EventItemDate;

// src/components/events/card/Item.tsx
import { jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var EventItem = ({ event, className }) => {
  var _a;
  const { t } = useTranslation2(["calendar_event", "calendar_common"]);
  const { locale } = useRouter2();
  const { toggleFavorite, isFavorite } = useFavorites();
  const isFaved = isFavorite(event.slug);
  const { design } = useConfig_default();
  const variant = (_a = design == null ? void 0 : design.eventItemDate) == null ? void 0 : _a.variant;
  return /* @__PURE__ */ jsx3(
    Button,
    {
      theme: "transparent",
      as: Link,
      "data-testid": `item_${event.slug}`,
      className: twMerge3("group relative h-full w-full gap-0 bg-transparent p-0", className),
      to: `/${locale}/${event.category.slug}/${event.slug}`,
      children: /* @__PURE__ */ jsxs3("div", { className: "bg-body rounded-S flex h-full w-full flex-col items-start overflow-hidden", children: [
        /* @__PURE__ */ jsxs3("div", { className: "rounded-S relative w-full overflow-hidden", children: [
          /* @__PURE__ */ jsx3(
            Button,
            {
              onClick: (e) => {
                e.preventDefault();
                e.stopPropagation();
                toggleFavorite(event.slug, event.title);
              },
              className: "hover:bg-body/10 absolute top-1 rounded-full p-2 ltr:right-0 rtl:left-1",
              shape: "text",
              "aria-label": isFaved ? t("calendar_common:favorites.remove") : t("calendar_common:favorites.add"),
              children: isFaved ? /* @__PURE__ */ jsx3(Heart, { className: "text-error stroke-body-light h-6 w-6 object-contain" }) : /* @__PURE__ */ jsx3(Heart, { className: "stroke-body-light text-body-dark/10 h-6 w-6 object-contain" })
            }
          ),
          /* @__PURE__ */ jsx3(
            ContentfulMedia_default,
            {
              className: "aspect-1 h-full object-cover",
              media: event.image11,
              width: 600,
              height: 600,
              ratio: "1x1",
              fit: "thumb",
              placeholder: true
            }
          )
        ] }),
        /* @__PURE__ */ jsxs3("div", { className: "p-M bg-body gap-M z-10 -mt-2 flex w-full", children: [
          variant === "inline" && /* @__PURE__ */ jsxs3(Fragment2, { children: [
            /* @__PURE__ */ jsx3(Date_default, { event, className: "px-XS" }),
            /* @__PURE__ */ jsx3(Divider, { className: "bg-secondary-600 h-full w-px" })
          ] }),
          /* @__PURE__ */ jsxs3("div", { className: "rounded-b-S gap-XXS bg-body-light flex w-full flex-1 flex-col text-start", children: [
            /* @__PURE__ */ jsx3(Type_default, { showDate: false, event }),
            /* @__PURE__ */ jsx3(Typography3, { variant: "heading-S", color: "text-primary", className: "line-clamp-2", children: event.title }),
            /* @__PURE__ */ jsx3(Location_default, { location: event.location, className: "text-text-secondary" }),
            /* @__PURE__ */ jsx3("div", { className: "flex flex-1 flex-col items-start justify-end", children: /* @__PURE__ */ jsx3(Price_default, { event }) }),
            /* @__PURE__ */ jsx3(Sellers_default, { sellers: event.sellersCollection, link: false })
          ] }),
          variant === "pop" && /* @__PURE__ */ jsx3(Date_default, { event, className: "px-S" })
        ] })
      ] })
    },
    event.id
  );
};
var Item_default = EventItem;

// src/components/events/NumberedCarousel.tsx
import { jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
var NumberedCarousel = ({ section, className }) => {
  const events = section.contentCollection.items;
  if (!(events == null ? void 0 : events.length)) {
    return null;
  }
  return /* @__PURE__ */ jsxs4(
    DecoratedSection_default,
    {
      section,
      "data-testid": `section_events_numbered_carousel_${section.id}`,
      className,
      children: [
        /* @__PURE__ */ jsx4(Title_default, { section }),
        /* @__PURE__ */ jsx4(
          Carousel,
          {
            options: { dragFree: true },
            className: "py-1",
            arrowsClassName: "hidden 2xl:block container",
            arrows: "middle",
            children: events.map((event, i) => /* @__PURE__ */ jsxs4(
              "div",
              {
                className: "relative flex shrink-0 basis-[360px] sm:basis-[440px] ltr:mr-6 rtl:ml-6",
                children: [
                  /* @__PURE__ */ jsx4(Item_default, { event }),
                  /* @__PURE__ */ jsx4(
                    Typography4,
                    {
                      variant: "display-L",
                      className: "text-secondary-700 w-28 shrink-0 self-center whitespace-nowrap text-nowrap !text-[250px] sm:w-32 ltr:-ml-12 ltr:sm:-ml-10 rtl:-mr-12 rtl:sm:-mr-10",
                      children: i + 1
                    }
                  )
                ]
              },
              i
            ))
          }
        )
      ]
    }
  );
};
var NumberedCarousel_default = NumberedCarousel;

// src/components/events/EventCarousel.tsx
import { useMemo as useMemo2, useState } from "react";
import { Carousel as Carousel2 } from "@wbk/ui";

// src/components/filters/categories/Link.tsx
import { Spinner, Typography as Typography5 } from "@wbk/ui";
import { CloseIcon } from "@wbk/svg";
import { jsx as jsx5, jsxs as jsxs5 } from "react/jsx-runtime";
var CategoryLink = ({ item, onClick, selected, total, totalLoading }) => {
  return /* @__PURE__ */ jsxs5(
    ThemeButton_default,
    {
      theme: "secondary",
      className: "aria-pressed:border-primary bg-category shadow-category aria-[pressed=false]:border-category group flex shrink-0 items-center border-2 border-transparent transition-all",
      "aria-pressed": selected,
      onClick,
      children: [
        /* @__PURE__ */ jsxs5("div", { className: "flex items-center gap-1", children: [
          item.icon && /* @__PURE__ */ jsx5(
            ContentfulMedia_default,
            {
              media: item.icon,
              width: 80,
              height: 80,
              className: "h-5 w-5",
              format: null
            }
          ),
          /* @__PURE__ */ jsx5(Typography5, { variant: "label-L", children: item.title }),
          totalLoading ? /* @__PURE__ */ jsx5(Spinner, { className: "h-3 w-3" }) : total ? /* @__PURE__ */ jsx5(Typography5, { variant: "label-S", children: `(${total})` }) : null
        ] }),
        selected && /* @__PURE__ */ jsx5(CloseIcon, { className: "h-3 w-3 shrink-0" })
      ]
    }
  );
};
var Link_default = CategoryLink;

// src/components/events/EventCarousel.tsx
import { jsx as jsx6, jsxs as jsxs6 } from "react/jsx-runtime";
var EventsCarousel = ({ section, className }) => {
  const events = section.contentCollection.items;
  const [category, setCategory] = useState();
  const { categories, filteredEvents } = useMemo2(() => {
    const seenCategories = /* @__PURE__ */ new Set();
    const uniqueCategories = [];
    const filtered = [];
    for (const event of events) {
      if (!seenCategories.has(event.category.slug)) {
        seenCategories.add(event.category.slug);
        uniqueCategories.push(event.category);
      }
      if (!category || event.category.slug === category) {
        filtered.push(event);
      }
    }
    return {
      categories: uniqueCategories,
      filteredEvents: filtered
    };
  }, [events, category]);
  if (!(events == null ? void 0 : events.length)) {
    return null;
  }
  return /* @__PURE__ */ jsxs6(
    DecoratedSection_default,
    {
      section,
      className,
      "data-testid": `section_events_carousel_${section.id}`,
      children: [
        /* @__PURE__ */ jsx6(Title_default, { section }),
        !!categories.length && categories.length > 1 && /* @__PURE__ */ jsx6(Carousel2, { containerClassName: "flex gap-2", children: categories.map((item) => {
          const active = category === (item == null ? void 0 : item.slug);
          return /* @__PURE__ */ jsx6(
            Link_default,
            {
              item,
              selected: active,
              onClick: () => setCategory(active ? void 0 : item.slug)
            },
            item.id
          );
        }) }),
        /* @__PURE__ */ jsx6(
          Carousel2,
          {
            className: "p-0.5",
            arrows: "middle",
            options: { dragFree: true },
            arrowsClassName: "hidden 2xl:block",
            children: filteredEvents.map((event) => /* @__PURE__ */ jsx6("div", { className: "relative shrink-0 basis-72 sm:basis-80 ltr:mr-4 rtl:ml-4", children: /* @__PURE__ */ jsx6(Item_default, { event }) }, event.id))
          }
        )
      ]
    }
  );
};
var EventCarousel_default = EventsCarousel;

// src/components/cards/Icons.tsx
import { Fragment as Fragment3 } from "react";
import { Carousel as Carousel3, Divider as Divider2 } from "@wbk/ui";
import { Fragment as Fragment4, jsx as jsx7, jsxs as jsxs7 } from "react/jsx-runtime";
var CardIcons = ({ section }) => {
  const cards = section.contentCollection.items;
  if (!(cards == null ? void 0 : cards.length))
    return null;
  return /* @__PURE__ */ jsxs7(Fragment4, { children: [
    cards.length <= 5 && /* @__PURE__ */ jsx7(
      DecoratedSection_default,
      {
        section,
        className: "hidden lg:block",
        "data-testid": `section_cards_icons_${section.id}`,
        children: /* @__PURE__ */ jsx7("ul", { className: "flex p-0.5", children: cards.map((card, i) => {
          return /* @__PURE__ */ jsxs7(Fragment3, { children: [
            /* @__PURE__ */ jsx7("li", { className: "h-full w-full", children: /* @__PURE__ */ jsx7(IconItem_default, { card, className: "block disabled:bg-transparent" }) }),
            i < cards.length - 1 && /* @__PURE__ */ jsx7("li", { className: "m-auto h-4/6", children: /* @__PURE__ */ jsx7(Divider2, { className: "bg-paper h-full w-px" }) })
          ] }, card.id);
        }) })
      }
    ),
    /* @__PURE__ */ jsx7(
      DecoratedSection_default,
      {
        section,
        groupClassName: "data-[with-grid=true]:lg:hidden ",
        "data-with-grid": cards.length <= 5,
        "data-testid": `section_cards_icons_${section.id}`,
        children: /* @__PURE__ */ jsx7(
          Carousel3,
          {
            as: "ul",
            rootClassName: "w-full overflow-hidden",
            arrowsClassName: "[&>button]:!bg-transparent",
            className: "p-1",
            options: { dragFree: true },
            arrows: "middle",
            children: cards.map((card, i) => {
              return /* @__PURE__ */ jsxs7(Fragment3, { children: [
                /* @__PURE__ */ jsx7("li", { className: "h-full shrink-0 basis-1/3 sm:basis-64 md:basis-80", children: /* @__PURE__ */ jsx7(IconItem_default, { card }) }),
                i < cards.length - 1 && /* @__PURE__ */ jsx7("li", { className: "m-auto h-4/6", children: /* @__PURE__ */ jsx7(Divider2, { className: "bg-paper h-full w-px" }) })
              ] }, card.id);
            })
          }
        )
      }
    )
  ] });
};
var Icons_default = CardIcons;

// src/components/cards/Carousel.tsx
import { Button as Button2, Carousel as Carousel4, Typography as Typography6 } from "@wbk/ui";
import { Link as Link2 } from "@wbk/config";
import { jsx as jsx8, jsxs as jsxs8 } from "react/jsx-runtime";
var CardsCarousel = ({ section }) => {
  const cards = section.contentCollection.items;
  if (!(cards == null ? void 0 : cards.length))
    return null;
  return /* @__PURE__ */ jsxs8(DecoratedSection_default, { section, "data-testid": `section_cards_carousel_${section.id}`, children: [
    /* @__PURE__ */ jsx8(Title_default, { section }),
    /* @__PURE__ */ jsx8(
      Carousel4,
      {
        options: { dragFree: true },
        className: "p-0.5",
        arrowsClassName: "container hidden 2xl:block",
        arrows: "middle",
        children: cards.map((card) => {
          var _a, _b;
          return /* @__PURE__ */ jsxs8(
            Button2,
            {
              theme: "black",
              as: ((_a = card.button) == null ? void 0 : _a.href) ? Link2 : "div",
              className: "rounded-L relative flex shrink-0 basis-[200px] flex-col gap-0 p-0 text-start ltr:mr-6 rtl:ml-6",
              href: (_b = card.button) == null ? void 0 : _b.href,
              "data-testid": `card_item_${card.id}`,
              children: [
                card.background && /* @__PURE__ */ jsx8(
                  ContentfulMedia_default,
                  {
                    className: "aspect-[2/3] object-cover",
                    media: card.background,
                    ratio: "3x1",
                    fit: "thumb",
                    placeholder: true
                  }
                ),
                /* @__PURE__ */ jsx8(Typography6, { variant: "heading-S", className: "w-full p-4", children: card.title })
              ]
            },
            card.id
          );
        })
      }
    )
  ] });
};
var Carousel_default = CardsCarousel;

// src/components/events/ScheduleCarousel.tsx
import { useState as useState2 } from "react";
import { useRouter as useRouter3, useTranslation as useTranslation3 } from "@wbk/config";
import { Button as Button3, Carousel as Carousel5, Menu, Typography as Typography7 } from "@wbk/ui";
import { ChevronIcon, SearchIcon } from "@wbk/svg";

// src/components/ui/Loading/CategoryLoading.tsx
import { jsx as jsx9 } from "react/jsx-runtime";
var CategoryLoading = () => {
  return /* @__PURE__ */ jsx9("div", { className: "flex overflow-hidden", children: Array.from({ length: 5 }).map((_, index) => /* @__PURE__ */ jsx9(
    "div",
    {
      className: "bg-body-level-2 h-12 w-36 shrink-0 animate-pulse rounded-md ltr:mr-4 rtl:ml-4"
    },
    index
  )) });
};
var CategoryLoading_default = CategoryLoading;

// src/components/ui/Loading/EventLoading.tsx
import { twMerge as twMerge4 } from "tailwind-merge";
import { ImageWithPlaceholder } from "@wbk/ui";
import { jsx as jsx10, jsxs as jsxs9 } from "react/jsx-runtime";
var EventLoading = ({ type = "grid", count = 12, className }) => {
  return /* @__PURE__ */ jsx10(
    "div",
    {
      className: twMerge4(
        type === "grid" ? "grid grid-cols-1 gap-4 sm:grid-cols-[repeat(auto-fill,minmax(285px,1fr))]" : "flex [&>div]:me-4 [&>div]:shrink-0 [&>div]:basis-72 [&>div]:sm:basis-80",
        "shrink-0",
        className
      ),
      children: [...Array(count)].map((_, index) => {
        return /* @__PURE__ */ jsxs9("div", { className: "bg-body-level-2 rounded-S overflow-hidden", children: [
          /* @__PURE__ */ jsx10(ImageWithPlaceholder, { className: "aspect-1 animate-pulse" }),
          /* @__PURE__ */ jsxs9("div", { className: "p-M space-y-2", children: [
            /* @__PURE__ */ jsx10("div", { className: "bg-body-level-1 h-4 w-1/2 animate-pulse" }),
            /* @__PURE__ */ jsx10("div", { className: "bg-body-level-1 h-4 w-3/4 animate-pulse" }),
            /* @__PURE__ */ jsx10("div", { className: "bg-body-level-1 h-4 w-1/2 animate-pulse" }),
            /* @__PURE__ */ jsx10("div", { className: "bg-body-level-1 h-4 w-3/4 animate-pulse" })
          ] })
        ] }, index);
      })
    }
  );
};
var EventLoading_default = EventLoading;

// src/components/events/ScheduleCarousel.tsx
import { jsx as jsx11, jsxs as jsxs10 } from "react/jsx-runtime";
var TYPES = ["day", "thisweek", "thismonth"];
var EventsScheduleCarousel = ({ section, className }) => {
  const { t } = useTranslation3("calendar_common");
  const { locale } = useRouter3();
  const [filter, setFilter] = useState2("day");
  const [category, setCategory] = useState2();
  const { query } = useFilterQuery_default({
    state: { category: category == null ? void 0 : category.slug, date: filter === "day" ? "today" : filter }
  });
  const { data, isLoading } = useGetEventsList({
    lang: locale,
    limit: 20,
    where: query.where
  });
  return /* @__PURE__ */ jsxs10(
    DecoratedSection_default,
    {
      section,
      className,
      "data-testid": `section_events_schedule_carousel_${section.id}`,
      children: [
        /* @__PURE__ */ jsxs10("div", { className: "relative space-y-2", children: [
          section.title && /* @__PURE__ */ jsxs10("div", { className: "inline gap-2", children: [
            /* @__PURE__ */ jsx11(Typography7, { as: "h2", variant: "heading-XXL", className: "inline", children: section.title }),
            /* @__PURE__ */ jsx11(
              Menu,
              {
                className: "inline",
                render: ({ open }) => /* @__PURE__ */ jsxs10(Button3, { shape: "text", className: "inline-flex px-2 py-1", onClick: open, children: [
                  /* @__PURE__ */ jsx11(Typography7, { as: "span", variant: "heading-XXL", color: "tertiary", children: t(`calendar_common:date.${filter}`) }),
                  /* @__PURE__ */ jsx11(ChevronIcon, { className: "text-tertiary h-3 w-3 shrink-0 rotate-90" })
                ] }),
                trigger: { theme: "primary" },
                item: { theme: "primary" },
                value: filter,
                options: TYPES.map((type) => ({
                  value: type,
                  text: /* @__PURE__ */ jsx11(Typography7, { variant: "heading-XS", children: t(`calendar_common:date.${type}`) })
                })),
                onChange: (e) => setFilter(e.value)
              }
            )
          ] }),
          section.subtitle && /* @__PURE__ */ jsx11(Typography7, { variant: "body-L", children: section.subtitle })
        ] }),
        /* @__PURE__ */ jsx11(Categories, { category, setCategory }),
        isLoading ? /* @__PURE__ */ jsx11(EventLoading_default, { count: 4, type: "carousel" }) : data && !!(data == null ? void 0 : data.items.length) ? /* @__PURE__ */ jsx11(
          Carousel5,
          {
            className: "p-0.5",
            arrowsClassName: "hidden 2xl:block container",
            arrows: "middle",
            options: { dragFree: true },
            children: data.items.map((event, i) => /* @__PURE__ */ jsx11("div", { className: "relative shrink-0 basis-72 sm:basis-80 ltr:mr-4 rtl:ml-4", children: /* @__PURE__ */ jsx11(Item_default, { event }) }, i))
          }
        ) : /* @__PURE__ */ jsxs10("div", { className: "flex h-[400px] flex-col items-center justify-center space-y-6 py-4 text-center", children: [
          /* @__PURE__ */ jsx11("div", { className: "bg-body-level-2 mx-auto flex h-24 w-24 items-center justify-center space-y-4 rounded-full text-center", children: /* @__PURE__ */ jsx11(SearchIcon, { className: "h-14 w-14 shrink-0" }) }),
          /* @__PURE__ */ jsx11("div", { className: "space-y-2", children: /* @__PURE__ */ jsx11(Typography7, { variant: "heading-L", as: "h4", children: t("calendar_common:empty_events") }) })
        ] })
      ]
    }
  );
};
var Categories = ({ category, setCategory }) => {
  const { locale } = useRouter3();
  const { data: categories, isLoading: isCategoriesLoading } = useGetCategories({
    lang: locale,
    where: { parent_exists: false },
    limit: 20
  });
  return /* @__PURE__ */ jsx11("div", { className: "space-y-2", children: isCategoriesLoading ? /* @__PURE__ */ jsx11(CategoryLoading_default, {}) : categories && !!categories.length ? /* @__PURE__ */ jsx11(Carousel5, { as: "ul", containerClassName: "flex gap-2", className: "py-px", children: categories.map((item) => {
    const active = (category == null ? void 0 : category.slug) === item.slug;
    return /* @__PURE__ */ jsx11("li", { className: "shrink-0", children: /* @__PURE__ */ jsx11(
      Link_default,
      {
        item,
        selected: active,
        onClick: () => setCategory(active ? void 0 : item)
      }
    ) }, item.id);
  }) }) : null });
};
var ScheduleCarousel_default = EventsScheduleCarousel;

// src/components/category/Carousel.tsx
import { Link as Link3, useRouter as useRouter4 } from "@wbk/config";
import { Button as Button4, Carousel as Carousel6, Typography as Typography8 } from "@wbk/ui";
import { twMerge as twMerge5 } from "tailwind-merge";
import { jsx as jsx12, jsxs as jsxs11 } from "react/jsx-runtime";
var CategoryCarousel = ({ section, className }) => {
  const items = section.contentCollection.items;
  const { locale } = useRouter4();
  return /* @__PURE__ */ jsxs11(
    DecoratedSection_default,
    {
      section,
      className: twMerge5("flex flex-col gap-2 md:flex-row md:items-center", className),
      "data-testid": `section_category_carousel_${section.id}`,
      children: [
        /* @__PURE__ */ jsxs11("div", { className: "container mx-0 text-balance p-0 md:max-w-[280px]", children: [
          section.title && /* @__PURE__ */ jsx12(Typography8, { as: "h2", variant: "heading-XXL", children: section.title }),
          section.subtitle && /* @__PURE__ */ jsx12(Typography8, { variant: "heading-L", className: "my-2", children: section.subtitle })
        ] }),
        /* @__PURE__ */ jsx12(
          Carousel6,
          {
            rootClassName: "w-full overflow-hidden",
            options: { dragFree: true },
            className: "p-0.5",
            arrowsClassName: "container hidden 2xl:block",
            arrows: "middle",
            children: items.map((item) => /* @__PURE__ */ jsx12(
              Button4,
              {
                as: Link3,
                to: `/${locale}/${item.slug}`,
                className: "group relative flex shrink-0 basis-80 flex-col items-center justify-center gap-2 p-0 sm:basis-96 ltr:mr-4 rtl:ml-4",
                theme: "white",
                shape: "text",
                "data-bg": !!item.background,
                children: /* @__PURE__ */ jsxs11("div", { className: "rounded-S bg-body border-paper relative aspect-[3/2] w-full overflow-hidden border", children: [
                  item.background && /* @__PURE__ */ jsx12(
                    ContentfulMedia_default,
                    {
                      className: "h-full w-full object-cover",
                      media: item.background,
                      placeholder: true
                    }
                  ),
                  /* @__PURE__ */ jsxs11(
                    "div",
                    {
                      className: twMerge5(
                        "absolute inset-0 left-0 top-0 flex flex-col items-center justify-center gap-1 transition-all",
                        item.background ? "text-body-light bg-body-dark/40 hover:bg-body-dark/20" : "text-body-dark hover:opacity-70"
                      ),
                      children: [
                        item.icon && /* @__PURE__ */ jsx12(
                          ContentfulMedia_default,
                          {
                            media: item.icon,
                            width: 50,
                            height: 50,
                            className: "aspect-1 object-contain group-data-[bg=true]:invert"
                          }
                        ),
                        /* @__PURE__ */ jsx12(Typography8, { variant: "heading-S", children: item.title })
                      ]
                    }
                  )
                ] })
              },
              item.id
            ))
          }
        )
      ]
    }
  );
};
var Carousel_default2 = CategoryCarousel;

// src/components/cards/Rectangular.tsx
import { Carousel as Carousel7 } from "@wbk/ui";

// src/components/cards/Item.tsx
import { twMerge as twMerge6 } from "tailwind-merge";
import { Button as Button5, Typography as Typography9 } from "@wbk/ui";
import { Link as Link4, useRouter as useRouter5 } from "@wbk/config";
import { jsx as jsx13, jsxs as jsxs12 } from "react/jsx-runtime";
var CardItem = ({ card, className }) => {
  var _a, _b, _c, _d, _e;
  const { locale } = useRouter5();
  const isExternal = (_b = (_a = card.button) == null ? void 0 : _a.href) == null ? void 0 : _b.startsWith("http");
  return /* @__PURE__ */ jsxs12(
    Button5,
    {
      theme: "transparent",
      as: ((_c = card.button) == null ? void 0 : _c.href) ? Link4 : "div",
      className: twMerge6(
        "rounded-L group relative w-full justify-start gap-0 bg-transparent p-0 text-start",
        className
      ),
      href: isExternal ? (_d = card.button) == null ? void 0 : _d.href : removeDuplicateSlashes(`/${locale}/${(_e = card.button) == null ? void 0 : _e.href}`),
      target: isExternal ? "_blank" : void 0,
      rel: isExternal ? "noopener noreferrer" : void 0,
      "data-testid": `card_item_${card.id}`,
      children: [
        card.background && /* @__PURE__ */ jsx13(
          ContentfulMedia_default,
          {
            className: "aspect-1 absolute h-full object-cover",
            media: card.background,
            ratio: "3x1",
            fit: "thumb",
            placeholder: true
          }
        ),
        /* @__PURE__ */ jsxs12("div", { className: "relative z-10 w-full space-y-10 p-6", children: [
          /* @__PURE__ */ jsxs12("div", { className: "space-y-1", children: [
            /* @__PURE__ */ jsxs12("div", { className: "flex items-center justify-between gap-2", children: [
              /* @__PURE__ */ jsx13(
                Typography9,
                {
                  variant: "heading-L",
                  className: "font-label text-body-light sm:text-heading-XXL",
                  children: card.title
                }
              ),
              /* @__PURE__ */ jsx13(Typography9, { variant: "heading-S", className: "font-label text-body-light", children: card.subtitle })
            ] }),
            card.description && /* @__PURE__ */ jsx13(CollapsableText_default, { className: "text-body-light", markdown: true, children: card.description })
          ] }),
          card.button && /* @__PURE__ */ jsx13(
            ContentfulButton_default,
            {
              className: "w-fit",
              button: __spreadProps(__spreadValues({}, card.button), {
                //  href managed by the parent element
                href: ""
              }),
              tabIndex: -1
            }
          )
        ] })
      ]
    },
    card.id
  );
};
var Item_default2 = CardItem;

// src/components/cards/Rectangular.tsx
import { jsx as jsx14, jsxs as jsxs13 } from "react/jsx-runtime";
var RectangularCarousel = ({ section }) => {
  const cards = section.contentCollection.items;
  if (!(cards == null ? void 0 : cards.length))
    return null;
  return /* @__PURE__ */ jsxs13(DecoratedSection_default, { section, "data-testid": `section_rectangular_carousel_${section.id}`, children: [
    /* @__PURE__ */ jsx14(Title_default, { section }),
    /* @__PURE__ */ jsx14(
      Carousel7,
      {
        options: { dragFree: true },
        className: "p-0.5",
        arrowsClassName: "container hidden 2xl:block",
        arrows: "middle",
        children: cards.map((card, i) => /* @__PURE__ */ jsx14(
          Item_default2,
          {
            card,
            className: "relative flex shrink-0 basis-72 sm:basis-[472px] ltr:mr-6 rtl:ml-6"
          },
          i
        ))
      }
    )
  ] });
};
var Rectangular_default = RectangularCarousel;

// src/components/category/RoundedCarousel.tsx
import { Button as Button6, Carousel as Carousel8, Typography as Typography10 } from "@wbk/ui";
import { twMerge as twMerge7 } from "tailwind-merge";
import { Link as Link5, useRouter as useRouter6 } from "@wbk/config";
import { jsx as jsx15, jsxs as jsxs14 } from "react/jsx-runtime";
var CategoryCarousel2 = ({ section, className }) => {
  const items = section.contentCollection.items;
  const { locale } = useRouter6();
  return /* @__PURE__ */ jsxs14(
    DecoratedSection_default,
    {
      section,
      className: twMerge7("flex flex-col gap-2 md:flex-row md:items-center", className),
      "data-testid": `section_category_carousel_${section.id}`,
      children: [
        /* @__PURE__ */ jsx15(Title_default, { section, className: "text-balance md:max-w-[220px]" }),
        /* @__PURE__ */ jsx15(
          Carousel8,
          {
            as: "ul",
            rootClassName: "w-full overflow-hidden",
            className: "p-1",
            arrows: "middle",
            options: { dragFree: true },
            arrowsClassName: "hidden 2xl:block container",
            children: items.map((item, i) => /* @__PURE__ */ jsx15("li", { className: "relative shrink-0 ltr:mr-6 rtl:ml-6", children: /* @__PURE__ */ jsxs14(
              Button6,
              {
                as: Link5,
                to: `/${locale}/${item.slug}`,
                className: "flex h-80 w-48 flex-col items-center justify-center gap-2",
                theme: "secondary",
                phill: true,
                shadow: "S",
                children: [
                  /* @__PURE__ */ jsx15(
                    ContentfulMedia_default,
                    {
                      width: 48,
                      height: 48,
                      className: "h-12 w-12 shrink-0",
                      media: item.icon
                    }
                  ),
                  /* @__PURE__ */ jsx15(Typography10, { variant: "heading-S", strong: true, children: item.title })
                ]
              }
            ) }, item.id + i))
          }
        )
      ]
    }
  );
};
var RoundedCarousel_default = CategoryCarousel2;

// src/components/cards/RoundedIcons.tsx
import { Carousel as Carousel9 } from "@wbk/ui";
import { jsx as jsx16 } from "react/jsx-runtime";
var CardRoundedIcons = ({ section }) => {
  const cards = section.contentCollection.items;
  if (!(cards == null ? void 0 : cards.length))
    return null;
  return /* @__PURE__ */ jsx16(DecoratedSection_default, { section, "data-testid": `section_cards_rounded_icons_${section.id}`, children: /* @__PURE__ */ jsx16(
    Carousel9,
    {
      as: "ul",
      options: { dragFree: true },
      arrowsClassName: "hidden 2xl:block",
      arrows: "middle",
      children: cards.map((card) => /* @__PURE__ */ jsx16("li", { className: "flex shrink-0 basis-72 p-1 ps-2.5 first:ps-1 sm:basis-80", children: /* @__PURE__ */ jsx16(IconItem_default, { className: "block w-full py-6 text-start", card }) }, card.id))
    }
  ) });
};
var RoundedIcons_default = CardRoundedIcons;

// src/components/events/CategoryCarousel.tsx
import { useMemo as useMemo3, useState as useState3 } from "react";
import { useRouter as useRouter7, useTranslation as useTranslation4 } from "@wbk/config";
import { Carousel as Carousel10, Typography as Typography11 } from "@wbk/ui";
import { SearchIcon as SearchIcon2 } from "@wbk/svg";
import { jsx as jsx17, jsxs as jsxs15 } from "react/jsx-runtime";
var EventsPerCategoryCarousel = ({ section, className }) => {
  var _a, _b;
  const { locale } = useRouter7();
  const { t } = useTranslation4("calendar_common");
  const [selected, setSelected] = useState3();
  const categories = useMemo3(() => {
    const list = [];
    const slugs = [];
    const items = section.contentCollection.items || [];
    for (const category of items) {
      if (category.__typename === "Category") {
        list.push(category);
        slugs.push(category.slug);
      }
    }
    return { list, slugs };
  }, [section.contentCollection.items]);
  const { data: events, isLoading } = useGetEventsList({
    lang: locale,
    limit: 50,
    where: {
      OR: [
        { category: { slug_in: selected ? [selected] : categories.slugs } },
        { subCategory: { slug_in: selected ? [selected] : categories.slugs } }
      ]
    }
  });
  if (!((_a = events == null ? void 0 : events.items) == null ? void 0 : _a.length)) {
    return null;
  }
  return /* @__PURE__ */ jsxs15(
    DecoratedSection_default,
    {
      section,
      className,
      "data-testid": `section_events_category_carousel_${section.id}`,
      children: [
        /* @__PURE__ */ jsx17(Title_default, { section }),
        categories.list.length > 1 && /* @__PURE__ */ jsx17(Carousel10, { as: "ul", containerClassName: "flex gap-2", className: "py-px", children: categories.list.map((category) => {
          const active = selected === category.slug;
          return /* @__PURE__ */ jsx17("li", { className: "shrink-0", children: /* @__PURE__ */ jsx17(
            Link_default,
            {
              item: category,
              selected: active,
              onClick: () => setSelected(active ? void 0 : category.slug)
            }
          ) }, category.id);
        }) }),
        isLoading ? /* @__PURE__ */ jsx17(EventLoading_default, { count: 4, type: "carousel" }) : ((_b = events == null ? void 0 : events.items) == null ? void 0 : _b.length) ? /* @__PURE__ */ jsx17(
          Carousel10,
          {
            className: "p-0.5",
            arrows: "middle",
            options: { dragFree: true },
            arrowsClassName: "hidden 2xl:block",
            children: events.items.map((event) => /* @__PURE__ */ jsx17(
              "div",
              {
                className: "relative shrink-0 basis-72 sm:basis-80 ltr:mr-4 rtl:ml-4",
                children: /* @__PURE__ */ jsx17(Item_default, { event })
              },
              event.id
            ))
          }
        ) : /* @__PURE__ */ jsxs15("div", { className: "flex h-[400px] flex-col items-center justify-center space-y-6 py-4 text-center", children: [
          /* @__PURE__ */ jsx17("div", { className: "bg-body-level-2 mx-auto flex h-24 w-24 items-center justify-center space-y-4 rounded-full text-center", children: /* @__PURE__ */ jsx17(SearchIcon2, { className: "h-14 w-14 shrink-0" }) }),
          /* @__PURE__ */ jsx17("div", { className: "space-y-2", children: /* @__PURE__ */ jsx17(Typography11, { variant: "heading-L", as: "h4", children: t("calendar_common:empty_events") }) })
        ] })
      ]
    }
  );
};
var CategoryCarousel_default = EventsPerCategoryCarousel;

// src/components/calendar/CalendarSection.tsx
import { formatDate as formatDate4 } from "@wbk/utils";
import { useRouter as useRouter13, useTranslation as useTranslation9 } from "@wbk/config";
import { Typography as Typography15 } from "@wbk/ui";

// src/components/calendar/monthly/index.tsx
import { useMemo as useMemo6 } from "react";
import { breakdownDurationToUnits, dateAdd, splitDateTime as splitDateTime3, startOfDay as startOfDay2 } from "@wbk/utils";
import { useRouter as useRouter12 } from "@wbk/config";

// src/components/calendar/monthly/Grid.tsx
import { useRouter as useRouter10, useTranslation as useTranslation7 } from "@wbk/config";
import { DayPicker, Typography as Typography13 } from "@wbk/ui";
import { splitDateTime } from "@wbk/utils";
import { WaveIcon } from "@wbk/svg";
import { twMerge as twMerge8 } from "tailwind-merge";

// src/components/ui/Loading/MonthlyPlaceholder.tsx
import { jsx as jsx18 } from "react/jsx-runtime";
var MonthlyPlaceholder = () => {
  return /* @__PURE__ */ jsx18("div", { className: "py-10 md:container", children: /* @__PURE__ */ jsx18("div", { className: "grid animate-pulse grid-cols-7 gap-1 py-5", children: Array.from({ length: 35 }, (_, i) => {
    return /* @__PURE__ */ jsx18("div", { className: "bg-body-level-2 h-20 border p-1 md:min-h-28 md:p-2" }, i);
  }) }) });
};
var MonthlyPlaceholder_default = MonthlyPlaceholder;

// src/components/calendar/monthly/DayCalendarEvents.tsx
import { ResponsiveModal } from "@wbk/ui";
import { useRouter as useRouter9, useTranslation as useTranslation6 } from "@wbk/config";
import { formatDate as formatDate2 } from "@wbk/utils";

// src/components/calendar/monthly/DayCalendarBody.tsx
import { Carousel as Carousel11 } from "@wbk/ui";
import { endOfDay, endOfMonth, startOfDay, startOfMonth } from "@wbk/utils";
import { useRouter as useRouter8 } from "@wbk/config";
import { jsx as jsx19 } from "react/jsx-runtime";
var DayCalendarBody = ({ events: propEvents, date }) => {
  const { locale } = useRouter8();
  const { getItinerary, id } = useItinerary();
  const itinerary = getItinerary(id);
  const { data, isLoading } = useGetEventsList(
    {
      lang: locale,
      where: {
        AND: [
          {
            OR: [
              {
                schedule: {
                  openDateTime_lte: endOfDay(new Date(date)),
                  closeDateTime_gte: startOfDay(new Date(date))
                }
              },
              {
                schedule: {
                  openDateTime_gte: startOfDay(new Date(date)),
                  openDateTime_lte: endOfDay(new Date(date))
                }
              }
            ]
          },
          {
            schedule: {
              openDateTime_gte: startOfMonth(new Date(date)),
              openDateTime_lte: endOfMonth(new Date(date))
            }
          }
        ]
      }
    },
    {
      enabled: !itinerary
    }
  );
  const fetchedEvents = (data == null ? void 0 : data.items) || [];
  const displayEvents = itinerary ? propEvents || [] : fetchedEvents;
  if (isLoading) {
    return /* @__PURE__ */ jsx19("div", { className: "overflow-hidden", children: /* @__PURE__ */ jsx19(EventLoading_default, { count: 2, type: "carousel" }) });
  }
  return /* @__PURE__ */ jsx19(Carousel11, { className: "py-0.5", arrows: "middle", options: { dragFree: true }, children: displayEvents.map((event, i) => /* @__PURE__ */ jsx19("div", { className: "relative shrink-0 basis-80 ltr:mr-4 rtl:ml-4", children: /* @__PURE__ */ jsx19(Item_default, { event }) }, i)) });
};
var DayCalendarBody_default = DayCalendarBody;

// src/components/calendar/monthly/DayCalendarRender.tsx
import { useMemo as useMemo4, useState as useState4 } from "react";
import { motion } from "motion/react";
import { useTranslation as useTranslation5 } from "@wbk/config";
import { Button as Button7, Popover, Typography as Typography12 } from "@wbk/ui";
import { useDeviceDetect } from "@wbk/hooks";
import { jsx as jsx20, jsxs as jsxs16 } from "react/jsx-runtime";
var DayCalendarRender = ({ open, events }) => {
  const { t } = useTranslation5("calendar_common");
  const { isDesktop } = useDeviceDetect();
  const [hoveredEvent, setHoveredEvent] = useState4(null);
  const limit = 3;
  const list = useMemo4(() => events.slice(0, limit), [events, limit]);
  return /* @__PURE__ */ jsxs16("div", { className: "grid grid-cols-2 gap-1 hover:opacity-70 sm:flex sm:flex-col sm:gap-2", children: [
    /* @__PURE__ */ jsx20(Button7, { onClick: open, className: "absolute inset-0", theme: "transparent" }),
    list.map((event) => /* @__PURE__ */ jsx20(
      Popover,
      {
        open: isDesktop && (hoveredEvent == null ? void 0 : hoveredEvent.id) === event.id,
        onOpenChange: (isOpen) => isDesktop && setHoveredEvent(isOpen ? event : null),
        side: "top",
        sideOffset: 8,
        align: "center",
        content: /* @__PURE__ */ jsx20(Item_default, { event }),
        className: "w-full max-w-xs [&>div]:p-0",
        children: /* @__PURE__ */ jsx20(
          motion.div,
          {
            onHoverStart: () => isDesktop && setHoveredEvent(event),
            onHoverEnd: () => isDesktop && setHoveredEvent(null),
            className: "rounded-radius relative block overflow-hidden",
            children: /* @__PURE__ */ jsxs16(
              Button7,
              {
                onClick: open,
                className: "rounded-radius sm:bg-body-level-1 flex w-full shrink-0 justify-start gap-2 overflow-hidden p-0 sm:p-1",
                shape: "text",
                theme: "transparent",
                children: [
                  /* @__PURE__ */ jsx20(
                    ContentfulMedia_default,
                    {
                      media: event.image11,
                      width: 32,
                      height: 32,
                      fit: "thumb",
                      ratio: "1x1",
                      placeholder: true,
                      className: "aspect-1 rounded-radius object-cover"
                    }
                  ),
                  /* @__PURE__ */ jsxs16("div", { className: "hidden flex-col text-start sm:flex", children: [
                    /* @__PURE__ */ jsx20(Typography12, { variant: "body-XS", className: "line-clamp-1 text-start", children: event.title }),
                    /* @__PURE__ */ jsx20(Date_default, { event, renderType: "mini" })
                  ] })
                ]
              }
            )
          }
        )
      },
      event.id
    )),
    events.length > limit && /* @__PURE__ */ jsxs16(
      Button7,
      {
        onClick: open,
        className: "rounded-XS bg-body-dark/70 flex items-center justify-center p-0 hover:bg-transparent sm:bg-transparent",
        children: [
          /* @__PURE__ */ jsxs16(Typography12, { variant: "label-XS", strong: true, className: "text-body-dark hidden sm:block", children: [
            "+",
            events.length - limit,
            " ",
            t("calendar_common:event_calendar.others")
          ] }),
          /* @__PURE__ */ jsxs16(Typography12, { variant: "label-XXS", className: "text-body-light shrink-0 sm:hidden", children: [
            events.length - limit,
            " +"
          ] })
        ]
      }
    )
  ] });
};
var DayCalendarRender_default = DayCalendarRender;

// src/components/calendar/monthly/DayCalendarEvents.tsx
import { jsx as jsx21 } from "react/jsx-runtime";
var DayCalendarEvents = ({ events, date }) => {
  const { t } = useTranslation6("calendar_common");
  const { locale } = useRouter9();
  return /* @__PURE__ */ jsx21(
    ResponsiveModal,
    {
      size: "7xl",
      title: t("calendar_common:event_calendar.day_modal_title", {
        day: date.getDate(),
        month: formatDate2(date, locale, { month: "long" }),
        year: date.getFullYear()
      }),
      cancel: false,
      action: false,
      render: ({ open }) => /* @__PURE__ */ jsx21(DayCalendarRender_default, { open, events }),
      body: () => /* @__PURE__ */ jsx21(DayCalendarBody_default, { date, events })
    }
  );
};
var DayCalendarEvents_default = DayCalendarEvents;

// src/components/calendar/monthly/Grid.tsx
import { Fragment as Fragment5, jsx as jsx22, jsxs as jsxs17 } from "react/jsx-runtime";
var MonthlyGridCalendar = ({ events, isLoading }) => {
  const { t } = useTranslation7("calendar_common");
  const { locale } = useRouter10();
  const { monthIndex, year } = useCalendarQuery_default();
  if (isLoading)
    return /* @__PURE__ */ jsx22(MonthlyPlaceholder_default, {});
  return /* @__PURE__ */ jsx22("div", { children: /* @__PURE__ */ jsx22(
    DayPicker,
    {
      lang: locale,
      classNames: {
        table: "container"
      },
      month: new Date(year, monthIndex),
      components: {
        Caption: () => /* @__PURE__ */ jsx22(Fragment5, {}),
        Day: ({ date }) => {
          const day = splitDateTime(date, "en", { month: "2-digit" });
          const { first = [], last = [] } = events[day.date] || {};
          const dayEvents = first.concat(last);
          const isWeekend = date.getDay() === 5 || date.getDay() === 6;
          if (dayEvents == null ? void 0 : dayEvents.length) {
            return /* @__PURE__ */ jsxs17(
              "div",
              {
                className: twMerge8(
                  "bg-body-light space-y-XS relative h-full border p-1 md:p-2",
                  isWeekend && "text-tertiary-100"
                ),
                children: [
                  /* @__PURE__ */ jsx22(Typography13, { variant: "label-L", className: "text-start", children: day.day }),
                  /* @__PURE__ */ jsx22(DayCalendarEvents_default, { events: dayEvents, date })
                ]
              }
            );
          }
          return /* @__PURE__ */ jsxs17("div", { className: "bg-body-level-1/20 space-y-XS flex h-full flex-col justify-center border p-1 md:p-2", children: [
            /* @__PURE__ */ jsx22(
              Typography13,
              {
                variant: "label-L",
                className: twMerge8("text-start", isWeekend && "text-tertiary-100"),
                children: day.day
              }
            ),
            /* @__PURE__ */ jsxs17("div", { className: "flex grow flex-col items-center justify-center space-y-1 py-4 md:space-y-1", children: [
              /* @__PURE__ */ jsx22(WaveIcon, { className: "h-2.5 w-5 object-contain" }),
              /* @__PURE__ */ jsx22(Typography13, { variant: "label-XS", children: t("calendar_common:event_calendar.no_events") })
            ] })
          ] });
        }
      }
    }
  ) });
};
var Grid_default = MonthlyGridCalendar;

// src/components/calendar/monthly/List.tsx
import { useMemo as useMemo5, useState as useState5 } from "react";
import { Button as Button8, Carousel as Carousel12, Typography as Typography14 } from "@wbk/ui";
import { formatDate as formatDate3, isSameDay, scrollIntoElementId, splitDateTime as splitDateTime2 } from "@wbk/utils";
import { DoubleArrowIcon } from "@wbk/svg";
import { useRouter as useRouter11, useTranslation as useTranslation8 } from "@wbk/config";

// src/components/ui/Loading/MonthlyListPlaceholder.tsx
import { jsx as jsx23, jsxs as jsxs18 } from "react/jsx-runtime";
var MonthlyListPlaceholder = ({ showDays = true }) => {
  return /* @__PURE__ */ jsxs18("div", { children: [
    showDays && /* @__PURE__ */ jsx23("div", { className: "container-1/2 flex gap-2 overflow-hidden md:container", children: Array.from({ length: 7 }, (_, i) => {
      return /* @__PURE__ */ jsx23(
        "div",
        {
          className: "bg-body-level-2 h-[120px] w-20 shrink-0 animate-pulse rounded-full"
        },
        i
      );
    }) }),
    /* @__PURE__ */ jsx23("div", { className: "container-1/2 space-y-4 py-10", children: Array.from({ length: 4 }, (_, i) => {
      return /* @__PURE__ */ jsxs18(
        "div",
        {
          className: "border-paper flex h-[300px] flex-col gap-5 border-b pb-6 last:border-none md:flex-row",
          children: [
            /* @__PURE__ */ jsx23("div", { className: "bg-body-level-2 h-16 w-40 animate-pulse rounded-md md:h-full" }),
            /* @__PURE__ */ jsx23("div", { className: "bg-body-level-2 h-full w-full animate-pulse rounded-md" })
          ]
        },
        i
      );
    }) })
  ] });
};
var MonthlyListPlaceholder_default = MonthlyListPlaceholder;

// src/components/calendar/monthly/List.tsx
import { Fragment as Fragment6, jsx as jsx24, jsxs as jsxs19 } from "react/jsx-runtime";
var MonthlyListCalendar = ({ events, isLoading }) => {
  const { t } = useTranslation8("calendar_common");
  const [openPast, setOpenPast] = useState5(false);
  const { locale } = useRouter11();
  const { days } = useCalendarQuery_default();
  const allEvents = useMemo5(() => {
    const initialIndex = days.findIndex(({ date }) => isSameDay(/* @__PURE__ */ new Date(), date));
    return {
      initialIndex,
      past: Object.entries(events.past),
      upcoming: Object.entries(events.upcoming)
    };
  }, [days, events.past, events.upcoming]);
  if (isLoading)
    return /* @__PURE__ */ jsx24(MonthlyListPlaceholder_default, {});
  return /* @__PURE__ */ jsxs19(Fragment6, { children: [
    /* @__PURE__ */ jsx24(
      Carousel12,
      {
        rootClassName: "container-1/2 md:container",
        options: { slidesToScroll: 1, startIndex: allEvents.initialIndex, dragFree: true },
        children: days.map(({ day, date, dayKey }) => {
          const { first = [], last = [] } = events.all[dayKey] || {};
          const hasEvents = first.length > 0 || last.length > 0;
          const isPast = /* @__PURE__ */ new Date() > date;
          const disabled = !hasEvents || isPast && !openPast || isPast && openPast && !hasEvents;
          return /* @__PURE__ */ jsx24(
            Button8,
            {
              theme: "secondary",
              className: "border-paper shrink-0 basis-20 rounded-full border py-8 text-center disabled:pointer-events-none disabled:select-none ltr:mr-2 rtl:ml-2",
              disabled,
              onClick: () => scrollIntoElementId(dayKey),
              children: /* @__PURE__ */ jsxs19("div", { className: "flex flex-col gap-1", children: [
                /* @__PURE__ */ jsx24(Typography14, { variant: "heading-XXS", children: formatDate3(date, locale, { weekday: "short" }) }),
                /* @__PURE__ */ jsx24(Typography14, { variant: "heading-S", children: formatDate3(date, locale, { day: "2-digit" }) })
              ] })
            },
            day
          );
        })
      }
    ),
    !openPast && allEvents.past.length > 0 && /* @__PURE__ */ jsx24("div", { className: "container flex justify-center pt-10", children: /* @__PURE__ */ jsxs19(
      Button8,
      {
        shape: "text",
        className: "border-paper text-text rounded-none border-y",
        onClick: () => setOpenPast(true),
        children: [
          t("calendar_common:event_calendar.browse_previous_events_this_month"),
          /* @__PURE__ */ jsx24(DoubleArrowIcon, { className: "mx-1" })
        ]
      }
    ) }),
    /* @__PURE__ */ jsxs19("div", { className: "container-1/2", children: [
      openPast ? days.map((date) => {
        var _a, _b;
        const key = date.dayKey;
        const splitdate = splitDateTime2(key, locale, { month: "long", day: "2-digit" });
        const first = ((_a = events.past[key]) == null ? void 0 : _a.first) || [];
        const last = ((_b = events.past[key]) == null ? void 0 : _b.last) || [];
        const dayEvents = first.concat(last);
        if (!dayEvents.length)
          return null;
        return /* @__PURE__ */ jsxs19(
          "div",
          {
            id: key,
            className: "border-paper flex scroll-mt-44 flex-col gap-4 border-b py-10 last:border-none md:flex-row md:items-center",
            children: [
              /* @__PURE__ */ jsxs19("div", { className: "container mx-0 flex w-auto min-w-36 items-baseline gap-2 md:flex-col md:items-start md:gap-0", children: [
                /* @__PURE__ */ jsx24(Typography14, { variant: "heading-XXL", children: splitdate.day }),
                /* @__PURE__ */ jsx24(Typography14, { variant: "heading-XXL", children: splitdate.month }),
                /* @__PURE__ */ jsx24(Typography14, { color: "text-secondary", className: "mx-1 md:mt-2", children: t("calendar_common:events.events_total", { count: dayEvents.length }) })
              ] }),
              /* @__PURE__ */ jsx24(Carousel12, { rootClassName: "w-full overflow-hidden", arrows: "middle", children: dayEvents.map((event) => /* @__PURE__ */ jsx24(
                "div",
                {
                  className: "relative shrink-0 basis-72 sm:basis-80 ltr:mr-4 rtl:ml-4",
                  children: /* @__PURE__ */ jsx24(Item_default, { event })
                },
                event.id
              )) })
            ]
          },
          key
        );
      }) : null,
      allEvents.upcoming.length > 0 ? days.map((date) => {
        var _a, _b;
        const key = date.dayKey;
        const splitdate = splitDateTime2(key, locale, { month: "long", day: "2-digit" });
        const today = /* @__PURE__ */ new Date();
        const isToday = isSameDay(today, date.date);
        const first = ((_a = events.upcoming[key]) == null ? void 0 : _a.first) || [];
        const last = ((_b = events.upcoming[key]) == null ? void 0 : _b.last) || [];
        const dayEvents = first.concat(last);
        if (!dayEvents.length)
          return null;
        return /* @__PURE__ */ jsxs19(
          "div",
          {
            id: key,
            className: "border-paper flex scroll-mt-44 flex-col gap-4 border-b py-10 last:border-none md:flex-row md:items-center",
            children: [
              /* @__PURE__ */ jsxs19("div", { className: "container mx-0 flex w-auto min-w-44 items-baseline gap-2 md:flex-col md:items-start md:gap-0", children: [
                /* @__PURE__ */ jsx24(Typography14, { variant: "heading-XXL", children: isToday ? t("calendar_common:date.today") : splitdate.day }),
                !isToday && /* @__PURE__ */ jsx24(Typography14, { variant: "heading-XXL", children: splitdate.month }),
                /* @__PURE__ */ jsx24(Typography14, { className: "mx-1 md:mt-2", color: "text-secondary", children: t("calendar_common:events.events_total", { count: dayEvents.length }) })
              ] }),
              /* @__PURE__ */ jsx24(
                Carousel12,
                {
                  rootClassName: "w-full text-center overflow-hidden",
                  className: "py-0.5",
                  arrows: "middle",
                  children: dayEvents.map((event) => /* @__PURE__ */ jsx24(
                    "div",
                    {
                      className: "relative shrink-0 basis-72 sm:basis-80 ltr:mr-4 rtl:ml-4",
                      children: /* @__PURE__ */ jsx24(Item_default, { event })
                    },
                    event.id
                  ))
                }
              )
            ]
          },
          key
        );
      }) : null
    ] }),
    !allEvents.upcoming.length && /* @__PURE__ */ jsxs19("div", { className: "container space-y-2 py-40 text-center", children: [
      /* @__PURE__ */ jsx24(Typography14, { variant: "heading-L", as: "h4", children: t("calendar_common:event_calendar.there_are_no_events") }),
      /* @__PURE__ */ jsx24(Typography14, { color: "text-secondary", children: t("calendar_common:event_calendar.no_events_available_for_this_month") })
    ] })
  ] });
};
var List_default = MonthlyListCalendar;

// src/components/calendar/monthly/index.tsx
import { jsx as jsx25 } from "react/jsx-runtime";
var MonthlyCalendar = ({ displayAs }) => {
  const { locale } = useRouter12();
  const { year, monthIndex } = useCalendarQuery_default();
  const firstDayOfMonth = new Date(year, monthIndex, 1);
  const lastDayOfMonth = new Date(year, monthIndex + 1, 0);
  const start = new Date(firstDayOfMonth);
  start.setDate(start.getDate() - 7);
  const end = new Date(lastDayOfMonth);
  end.setDate(end.getDate() + 7);
  const { query } = useFilterQuery_default();
  const { data, isLoading } = useGetEventsList({
    lang: locale,
    where: {
      OR: [__spreadValues({}, query.where), { schedule: { openDateTime_gte: start, openDateTime_lte: end } }]
    }
  });
  const events = useMemo6(() => {
    const all = {};
    const past = {};
    const upcoming = {};
    const start2 = startOfDay2(/* @__PURE__ */ new Date());
    for (const event of (data == null ? void 0 : data.items) || []) {
      if (!event.schedule.openDateTime || !event.schedule.closeDateTime)
        continue;
      const startDate = new Date(event.schedule.openDateTime);
      const endDate = new Date(event.schedule.closeDateTime);
      const { day } = breakdownDurationToUnits({ from: startDate, to: endDate, units: ["day"] });
      const safeDay = day || 0;
      for (let i = 0; i <= safeDay; i++) {
        const today = dateAdd({ date: startDate, interval: "day", value: i });
        if (!today)
          return;
        const dayKey = splitDateTime3(today, "en", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit"
        }).date;
        const isPast = today < start2;
        const category = isPast ? past : upcoming;
        if (!category)
          continue;
        if (!category[dayKey])
          category[dayKey] = { first: [], last: [] };
        if (i === 0) {
          category[dayKey].first.push(event);
        } else {
          category[dayKey].last.push(event);
        }
        if (!all[dayKey])
          all[dayKey] = { first: [], last: [] };
        if (i === 0) {
          all[dayKey].first.push(event);
        } else {
          all[dayKey].last.push(event);
        }
      }
    }
    return { all, past, upcoming };
  }, [data == null ? void 0 : data.items]);
  if (!events)
    return null;
  return displayAs === "grid" ? /* @__PURE__ */ jsx25(Grid_default, { events: events.all, isLoading }) : /* @__PURE__ */ jsx25(List_default, { events, isLoading });
};
var monthly_default = MonthlyCalendar;

// src/components/calendar/CalendarSection.tsx
import { jsx as jsx26, jsxs as jsxs20 } from "react/jsx-runtime";
var CalendarSection = ({ section }) => {
  const { locale } = useRouter13();
  const { t } = useTranslation9("calendar_common");
  const { monthIndex, year } = useCalendarQuery_default();
  const monthName = formatDate4(new Date(year, monthIndex), locale, { month: "long" });
  return /* @__PURE__ */ jsxs20(DecoratedSection_default, { section, "data-testid": `section_current_calendar_${section.id}`, children: [
    /* @__PURE__ */ jsx26(Typography15, { as: "h2", variant: "heading-XXL", children: t("calendar_common:current_calendar_title", { month: monthName }) }),
    /* @__PURE__ */ jsx26(monthly_default, { displayAs: "grid" })
  ] });
};
var CalendarSection_default = CalendarSection;

// src/components/section/HeroSection.tsx
import { CollapsibleText, Typography as Typography16 } from "@wbk/ui";
import { jsx as jsx27, jsxs as jsxs21 } from "react/jsx-runtime";
var HeroSection = ({ section }) => {
  var _a, _b;
  const card = (_a = section.contentCollection.items) == null ? void 0 : _a[0];
  if (!card)
    return null;
  const bg = card.image31;
  return /* @__PURE__ */ jsx27("section", { id: section.id, children: /* @__PURE__ */ jsxs21("div", { className: "before:bg-body-dark/20 relative flex min-h-[calc(100svh-140px)] flex-col justify-between before:absolute before:inset-0 before:-z-10", children: [
    card.background && /* @__PURE__ */ jsx27(
      ContentfulMedia_default,
      {
        media: card.background,
        className: "absolute -z-20 h-full w-full object-cover",
        autoPlay: true,
        muted: true,
        loop: true,
        playsInline: true,
        poster: (_b = section.sectionBackground) == null ? void 0 : _b.url
      }
    ),
    bg && /* @__PURE__ */ jsx27(
      ContentfulMedia_default,
      {
        media: bg,
        className: "absolute -z-10 h-full w-full object-cover",
        preload: ""
      }
    ),
    /* @__PURE__ */ jsxs21("div", { className: "text-body-light container flex min-h-[calc(85vh-80px)] flex-col justify-end pb-12 pt-32", children: [
      card.icon && /* @__PURE__ */ jsx27(
        ContentfulMedia_default,
        {
          media: card.icon,
          width: 100,
          height: 100,
          className: "shrink-0 object-contain pb-2"
        }
      ),
      /* @__PURE__ */ jsx27(Typography16, { as: "h1", variant: "display-L", children: card.title }),
      /* @__PURE__ */ jsxs21("div", { className: "space-y-M", children: [
        card.subtitle && /* @__PURE__ */ jsx27(Typography16, { variant: "display-XS", children: card.subtitle }),
        card.description && /* @__PURE__ */ jsx27(CollapsibleText, { className: "text-body-light", text: card.description }),
        /* @__PURE__ */ jsx27("div", { className: "gap-M flex flex-wrap items-center", children: section.linksCollection.items.map((link) => /* @__PURE__ */ jsx27(ContentfulButton_default, { button: link }, link.id)) })
      ] })
    ] })
  ] }) });
};
var HeroSection_default = HeroSection;

// src/components/section/ContentfulSection.tsx
import { jsx as jsx28 } from "react/jsx-runtime";
var ContentfulSection = ({ section }) => {
  var _a, _b, _c, _d, _e;
  switch (section.renderType) {
    case "hero":
      return /* @__PURE__ */ jsx28(HeroSection_default, { section });
    case "calendar":
      return /* @__PURE__ */ jsx28(CalendarSection_default, { section });
    case "collapsable-text":
      return /* @__PURE__ */ jsx28(CollapsableTextSection_default, { section });
    case "events-schedule":
      return /* @__PURE__ */ jsx28(ScheduleCarousel_default, { section });
    case "events-category":
      return /* @__PURE__ */ jsx28(CategoryCarousel_default, { section });
    default:
      break;
  }
  if (!((_b = (_a = section.contentCollection) == null ? void 0 : _a.items) == null ? void 0 : _b[0])) {
    return null;
  }
  const type = (_e = (_d = (_c = section.contentCollection) == null ? void 0 : _c.items) == null ? void 0 : _d[0]) == null ? void 0 : _e.__typename;
  switch (type) {
    case "Event":
      return section.renderType === "numbered-carousel" ? /* @__PURE__ */ jsx28(NumberedCarousel_default, { section }) : /* @__PURE__ */ jsx28(EventCarousel_default, { section });
    case "Card":
      return section.renderType === "icons" ? /* @__PURE__ */ jsx28(Icons_default, { section }) : section.renderType === "rectangular" ? /* @__PURE__ */ jsx28(Rectangular_default, { section }) : section.renderType === "icons-rounded" ? /* @__PURE__ */ jsx28(RoundedIcons_default, { section }) : /* @__PURE__ */ jsx28(Carousel_default, { section });
    case "Category":
      return section.renderType === "rectangular" ? /* @__PURE__ */ jsx28(Carousel_default2, { section }) : /* @__PURE__ */ jsx28(RoundedCarousel_default, { section });
    default:
      return null;
  }
};
var ContentfulSection_default = ContentfulSection;

export {
  Item_default,
  Link_default,
  EventCarousel_default,
  EventLoading_default,
  Grid_default,
  MonthlyListPlaceholder_default,
  monthly_default,
  ContentfulSection_default
};
//# sourceMappingURL=chunk-D3RK6H2X.mjs.map